export default {
  props: {
    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    cards: {
      type: [Array, Object],
    },

    contentBlock: {
      type: Object,
    },

    theme: {
      type: String,
      default: '',
      validator: prop => ['', 'light'].includes(prop),
    },
  },

  components: {
    hotSolutionsContentBlock: () =>
      import('~/components/Organisms/Solutions/SolutionsContentBlock/SolutionsContentBlock.vue'),
  },

  computed: {
    isLightTheme() {
      if (this.theme === 'light') return true

      return false
    },
  },
}
